/**
 * フロートバナー
 */
import ResizeWatch from '../utils/ResizeWatch';
import ScrollWatch from '../utils/ScrollWatch';
import AnyStore from '../common/AnyStore';

export default class FloatBanner {
  /**
   * コンストラクタ
   */
  constructor(isForce) {
    // クラス名
    this.name = 'FloatBanner';
    this.isShow = false;
    this.winH = 0;
    this.isBottom = false;
    this.isForce = (AnyStore.setDevice() === 'pc' && isForce === true);
    this.el = document.getElementById('p-floatBanner');

    if (this.el) {
      this.init();
    }
  }

  /**
   * 表示前
   */
  init() {
    //setTimeout(this.start.bind(this), 2000);
  }

  /**
   * 表示
   */
  start() {
    //TweenMax.set(this.el, {className: '+=is-show'});

    this.resizeUpdate();
  }

  scrollable() {
    if ((this.winH * 0.1) < AnyStore.getScrollTop()) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }

    ResizeWatch.registerObserver(this.name, this);
    ScrollWatch.registerObserver(this.name, this);
  }

  /**
   * スクロール
   */
  scrollUpdate(_scrollY) {
    //if (this.isForce) return;
    if ((this.winH * 0.1) < _scrollY) {
      // 消す
      if (!this.isShow) {
        this.isShow = true;
        TweenMax.set(this.el, {className: '+=is-show'});
      }
    } else {
      // 表示
      if (this.isShow) {
        this.isShow = false;
        TweenMax.set(this.el, {className: '-=is-show'});
      }
    }

    const footerY = document.body.scrollHeight - window.innerHeight - this.footerAdjust;
    if (_scrollY >= footerY) {
      if (!this.isBottom) {
        this.isBottom = true;
        TweenMax.set(this.el, {className: '-=is-show'});
      }
    } else {
      if (this.isBottom) {
        this.isBottom = false;
        TweenMax.set(this.el, {className: '+=is-show'});
      }
    }
  }

  /**
   * リサイズ
   */
  resizeUpdate() {
    this.winH = window.innerHeight;
    this.footerAdjust = document.getElementById('js-footer').clientHeight;
    this.scrollUpdate(AnyStore.getScrollTop());
  }

  check() {
    //this.isForce = false;
    this.resizeUpdate();
  }
}
